import { Button } from '@design-system/button';
import { FluidGrid } from '@design-system/fluid-grid';
import { PageBlock } from '@design-system/page-block';
import { Spacer } from '@design-system/spacer';
import React, { forwardRef } from 'react';

import { useLoadMore } from '~/hooks/useLoadMore';

import { ItemListingLoadMoreProps } from './models';

export const ItemListingLoadMore = forwardRef<
  HTMLDivElement,
  Omit<ItemListingLoadMoreProps, 'type'>
>(
  (
    {
      pageBlock,
      fluidGrid,
      items: articles,
      loadMoreButton,
      initialNumberArticles = 8,
      id,
      uid,
    },
    ref
  ) => {
    const { nextPage, visibleItems, nextPageButtonVisible } = useLoadMore({
      items: articles,
      itemsPerPage: initialNumberArticles,
    });

    return (
      <PageBlock
        {...pageBlock}
        ref={ref}
        className="load-more-block"
        id={id}
        componentUid={uid}
      >
        <div className="load-more-block__container">
          {visibleItems.length ? (
            <>
              <FluidGrid {...fluidGrid}>{visibleItems}</FluidGrid>
              <Spacer size={7} />
              {nextPageButtonVisible &&
              loadMoreButton?.children &&
              initialNumberArticles ? (
                <div className="load-more-block__button-container">
                  <Button
                    {...loadMoreButton}
                    onClick={nextPage}
                    className="load-more-block__button"
                  >
                    {loadMoreButton.children}
                  </Button>
                </div>
              ) : null}
            </>
          ) : null}
        </div>
      </PageBlock>
    );
  }
);

export default ItemListingLoadMore;
